import Page from '../Page';
import AccountSettingsTabs from './Components/AccountSettingsTabs';
import TopBar from '@/Components/TopBars/TopBar';
import withCompanyProfileRequired from '@/Routing/withCompanyProfileRequired';
import withSignupChecks from '@/Routing/withSignupChecks';
import withTalentMeshUserRequired from '@/Routing/withTalentMeshUserRequired';

function AccountSettingsPage() {
    return (
        <Page topBar={<TopBar />}>
            <AccountSettingsTabs />
        </Page>
    );
}

export default withCompanyProfileRequired(withTalentMeshUserRequired(withSignupChecks(AccountSettingsPage)));
